import { NotificationUpdate } from './notification.interface';

/**
 * Handle for controlling a notification programmatically.
 * Returned when creating a notification, allows updating and closing it.
 */
export class NotificationHandle {
	constructor(
		private readonly notificationId: string,
		private readonly updateCallback: (id: string, updates: NotificationUpdate) => void,
		private readonly closeCallback: (id: string) => void
	) {}

	/**
	 * Get the notification ID
	 */
	get id(): string {
		return this.notificationId;
	}

	/**
	 * Update the notification with new data
	 * @param updates - Partial updates to apply (message, progress, style)
	 */
	update(updates: NotificationUpdate): void {
		this.updateCallback(this.notificationId, updates);
	}

	/**
	 * Close the notification
	 */
	close(): void {
		this.closeCallback(this.notificationId);
	}

	/**
	 * Update the progress value
	 * @param progress - Progress value (-2 for spinner, -1 for none, 0-100 for progress wheel)
	 */
	setProgress(progress: number): void {
		this.update({ progress });
	}

	/**
	 * Update the message text
	 * @param message - New message text
	 */
	setMessage(message: string): void {
		this.update({ message });
	}
}
